import * as types from '../constants/action-types';
import Bookings from '../../../../api/api-bookings';
import Contracts from '../../../../api/api-contracts';

export function resetBookingStore () {
  return {
    type: types.RESET_BOOKING_STORE
  };
}

export function bookingFetchSuccess (booking) {
  return {
    type: types.BOOKING_FETCH_SUCCESS,
    booking
  };
}

export function bookingFetchFailure (error) {
  return {
    type: types.BOOKING_FETCH_FAILURE,
    error
  };
}

export function bookingFetchRequest (isFetching) {
  return {
    type: types.BOOKING_FETCH_REQUEST,
    isFetching
  };
}

export function bookingPrepareRequest (isPosting) {
  return {
    type: types.BOOKING_PREPARE_REQUEST,
    isPosting
  };
}

export function bookingPrepareFailure (error) {
  return {
    type: types.BOOKING_PREPARE_FAILURE,
    booking: { error }
  };
}

export function bookingPrepareSuccess (booking) {
  return {
    type: types.BOOKING_PREPARE_SUCCESS,
    booking
  };
}

export function bookingRequest200 (booking) {
  return {
    type: types.BOOKING_FORM_SUBMITTED,
    booking
  };
}

export function createBookingRequest (isPosting) {
  return {
    type: types.BOOKING_CREATE_REQUEST,
    isPosting
  };
}

export function createBookingSuccess (booking) {
  return {
    type: types.BOOKING_CREATE_SUCCESS,
    isPosting: false,
    booking
  };
}

export function createBookingFailure (error) {
  return {
    type: types.BOOKING_CREATE_FAILURE,
    isPosting: false,
    error
  };
}

export function fetchCancellationDetailsRequest (isPosting) {
  return {
    type: types.FETCH_CANCELLATION_DETAILS_REQUEST,
    isPosting
  };
}

export function fetchCancellationDetailsSuccess (booking) {
  return {
    type: types.FETCH_CANCELLATION_DETAILS_SUCCESS,
    booking
  };
}

export function fetchCancellationDetailsFailure (error) {
  return {
    type: types.FETCH_CANCELLATION_DETAILS_FAILURE,
    error
  };
}

export function createBooking (payload, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(createBookingRequest(true));
      Contracts.guestRequest(payload, accessToken, (response) => {
        if (400 === response.statusCode) {
          dispatch(createBookingFailure(response.error));
          return reject(new Error(response.error));
        }

        dispatch(createBookingSuccess(response));
        return resolve({ response });
      });
    });
  };
}

export function createGuestPaymentUpdate (controlId, payload, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(createBookingRequest(true));

      Contracts.guestPaymentUpdate(controlId, payload, accessToken, (response) => {
        if (400 === response.statusCode) {
          dispatch(createBookingFailure(response.error));
          return reject(response.error);
        }

        dispatch(createBookingSuccess(response));
        return resolve(response);
      });
    });
  };
}

export function createBookingFromInquiry (bookingId, payload, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(createBookingRequest(true));

      Contracts.inquiryToRequest(bookingId, payload, accessToken, (response) => {
        if (400 === response.statusCode) {
          dispatch(createBookingFailure(response.error));
          return reject(new Error(response.error));
        }

        dispatch(createBookingSuccess(response));
        resolve({ response });
      });
    });
  };
}

export function fetchBooking (bookingID, accessToken, callback) {
  return dispatch => {
    dispatch(bookingFetchRequest(true));
    Bookings.read(bookingID, accessToken, (response) => {

      if (400 === response.statusCode) {
        return dispatch(bookingFetchFailure(response.error));
      }

      if (callback) {
        callback(response);
      }

      dispatch(bookingFetchSuccess(response));
      return dispatch(bookingFetchRequest(false));
    });
  };
}

export function prepareBooking (payload, accessToken, callback) {
  return dispatch => {
    dispatch(bookingPrepareRequest(true));
    Contracts.guestRequestQuote(payload, accessToken, (response) => {
      dispatch(bookingPrepareRequest(false));

      if (callback) {
        callback(response);
      }

      if (400 === response.statusCode) {
        return dispatch(bookingPrepareFailure({
          ...response
        }));
      }

      return dispatch(bookingPrepareSuccess({
        ...response
      }));
    });
  };
}

export function bookingRequestSubmitted (booking) {
  return dispatch => {
    dispatch(bookingRequest200(booking));
  };
}

export function updateBooking (bookingId, payload, token, callback, guestUpdate) {
  return dispatch => {
    dispatch({ type: types.BOOKING_UPDATE_REQUEST });

    Bookings.update(bookingId, payload, token, (response) => {
      if (response.error) {
        return dispatch({ type: types.BOOKING_UPDATE_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.BOOKING_UPDATE_SUCCESS,
        payload: response
      });
    }, guestUpdate);
  };
}

export function updateBookingShareState (bookingId, shareState, token, callback) {
  const uri = `${bookingId}/guest/share/${shareState}`;

  return dispatch => {
    dispatch({ type: types.BOOKING_UPDATE_SHARE_STATE_REQUEST });

    Bookings.update(uri, null, token, (response) => {
      if (response.error) {
        return dispatch({ type: types.BOOKING_UPDATE_SHARE_STATE_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.BOOKING_UPDATE_SHARE_STATE_SUCCESS,
        payload: {
          ...response,
          shareState
        }
      });
    });
  };
}

export function fetchCancellationDetails (controlId, token, callback) {
  return dispatch => {
    dispatch(fetchCancellationDetailsRequest(true));

    Bookings.readCancellation(controlId, token, response => {
      if (callback) {
        callback(response);
      }

      if (response.error) {
        return dispatch(fetchCancellationDetailsFailure(response.error));
      }

      return dispatch(fetchCancellationDetailsSuccess(response));
    });
  };
}
